import React, { useState, useEffect, useRef, memo, useCallback } from "react";
import {
  useListContext,
  ListBase,
  useGetList,
  usePermissions,
  required,
  SelectInput,
  useCreate,
  useGetOne,
  SimpleForm,
  SaveButton,
  useUpdate,
  useNotify,
  useDataProvider,
  useRefresh,
  useRedirect,
} from "react-admin";
import MultiReservasModal from "./MultiReservasModal";
import { DateInput } from "../components/DatePicker";
import { Scheduler } from "@aldabil/react-scheduler";
import {
  Button,
  ButtonBase,
  DialogContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  TextField,
  Box,
  Divider,
  IconButton,
  Tooltip,
} from "@mui/material";
import { es } from "date-fns/esm/locale";
import { useNavigate, useSearchParams } from "react-router-dom";
import { format } from "date-fns";
import Firebase from "../Firebase/Firebase";
import moment from "moment";
import "moment/locale/es";
import { useFormContext } from "react-hook-form";
import {
  AttachMoney,
  Autorenew,
  MoneyOff,
  Computer,
  Beenhere,
  Cancel,
  CheckCircle,
  DoNotDisturb,
  HourglassEmpty,
  MarkEmailRead,
  PendingActions,
  Phone,
  ReportProblem,
  Tag,
  Star,
  Discount,
  Description,
  WhatsApp,
} from "@mui/icons-material";
import { STATUS_COLORS } from "./constants";
import { useProvider } from "../ProviderContext";
import QuickBookingModal from "./QuickBookingModal";

export const ScheduleList = (props) => {
  const [date, setDate] = useState(new Date().toISOString());
  const [timeUnit, setTimeUnit] = useState("day");
  const [serviceMethod, setServiceMethod] = useState("Ambos");
  const profile = JSON.parse(localStorage.getItem("profile"));
  // Para admin-sucursal, usar el ID de la sucursal, no el objeto completo
  const [branch, setBranch] = useState(profile?.branch?._id || profile?.branch);
  const [searchParams] = useSearchParams();
  const { permissions } = usePermissions();

  useEffect(() => {
    if (searchParams.get("date")) {
      setDate(new Date(searchParams.get("date")).toISOString());
    }
  }, [searchParams.get("date")]);

  useEffect(() => {
    if (searchParams.get("branch")) {
      setBranch(searchParams.get("branch"));
    }
  }, [searchParams.get("branch")]);

  useEffect(() => {
    if (searchParams.get("serviceMethod")) {
      setServiceMethod(searchParams.get("serviceMethod"));
    }
  }, [searchParams.get("serviceMethod")]);

  return (
    <Firebase>
      <ListBase
        {...props}
        filter={{
          date: date,
          timeUnit: timeUnit,
          serviceMethod: serviceMethod,
          branch: branch,
        }}
      >
        <br />
        <FormControl>
          <InputLabel id="demo-simple-select-label">Método</InputLabel>
          <Select
            style={{ width: 200 }}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={serviceMethod}
            label="Método"
            onChange={(e) => {
              setServiceMethod(e.target.value);
              if (e.target.value === "A domicilio") {
                setBranch(null);
              }
            }}
          >
            <MenuItem value="Ambos">Ambos</MenuItem>
            <MenuItem value="En sucursal">En sucursal</MenuItem>
            <MenuItem value="A domicilio">A domicilio</MenuItem>
          </Select>
        </FormControl>
        <br />
        {permissions !== "admin-sucursal" && (
          <SelectBranchInput serviceMethod={serviceMethod} branch={branch} setBranch={setBranch} />
        )}
        <Schedule
          date={date}
          serviceMethod={serviceMethod}
          branch={branch}
          setDate={setDate}
          setTimeUnit={setTimeUnit}
        />
      </ListBase>
    </Firebase>
  );
};

const CustomEditor = ({ scheduler, serviceMethod, branch, refresh, onOpenMultiReservas }) => {
  const navigate = useNavigate();
  const [openQuickBooking, setOpenQuickBooking] = useState(false);

  const handleQuickBookingSuccess = () => {
    setOpenQuickBooking(false); // Cerrar modal de Reserva Rápida
    scheduler.close(); // Cerrar modal del calendario
    refresh(); // Refrescar el calendario
  };
  const handleOpenMultiReservas = () => {
    const selectedDate = scheduler?.state?.start?.value;
    onOpenMultiReservas(selectedDate);
    scheduler.close();
  };

  return (
    <DialogContent>
      <Typography>Hora: {scheduler?.state?.start?.value.toLocaleTimeString("es-ES")}</Typography>
      <br />
      <Button variant="outlined" color="primary" onClick={() => setOpenQuickBooking(true)} fullWidth sx={{ mb: 2 }}>
        Reserva Rápida
      </Button>
      <br />
      <Button variant="outlined" color="primary" onClick={handleOpenMultiReservas} fullWidth sx={{ mb: 2 }}>
        Multi Reservas
      </Button>
      <Button
        variant="outlined"
        onClick={() =>
          navigate(
            `/booking/create?date=${scheduler?.state?.start?.value.toISOString()}&employee=${
              scheduler.admin_id
            }&serviceMethod=${serviceMethod}&branch=${branch}&redirect=schedule`
          )
        }
        fullWidth
      >
        Crear Reserva
      </Button>
      <br />
      <br />
      <Button
        variant="outlined"
        onClick={() =>
          navigate(
            `/booking/create?date=${scheduler?.state?.start?.value.toISOString()}&employee=${
              scheduler.admin_id
            }&serviceMethod=${serviceMethod}&branch=${branch}&redirect=schedule&type=sobreHorario`
          )
        }
        fullWidth
      >
        Sobre Horario
      </Button>
      <br />
      <br />
      <Button
        variant="outlined"
        onClick={() =>
          navigate(
            `/unavailability/create?date=${scheduler?.state?.start?.value.toISOString()}&employee=${
              scheduler.admin_id
            }&redirect=schedule`
          )
        }
        fullWidth
      >
        Horario No Disponible
      </Button>
      <br />
      <br />
      <Button variant="contained" onClick={scheduler.close} fullWidth>
        Cancelar
      </Button>

      {openQuickBooking && (
        <QuickBookingModal
          open={openQuickBooking}
          onClose={() => setOpenQuickBooking(false)}
          onSuccess={handleQuickBookingSuccess}
          schedulerData={{
            date: scheduler?.state?.start?.value,
            employeeId: scheduler.admin_id,
            branch: branch,
            serviceMethod: serviceMethod,
          }}
        />
      )}
    </DialogContent>
  );
};

const HourInput = ({ event, isDateBlocked }) => {
  const { watch, setValue } = useFormContext();
  const date = watch("date");
  const [hourPicker, setHourPicker] = useState([]);
  const [eventHour, setEventHour] = useState(null);
  const editedEstimatedWorkMinutes = watch("editedEstimatedWorkMinutes");
  useEffect(() => {
    _setHourPicker(moment(date));
    setValue("hour", "");
  }, [date]);
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (searchParams.get("date")) {
      setValue("date", new Date(searchParams.get("date")));
    }
  }, [searchParams.get("date")]);

  const [fetchAvailability] = useCreate();

  const _setHourPicker = async (date) => {
    const array = [];
    const today = moment();
    const isSameDay = moment(today).isSame(date, "day");
    const profile = JSON.parse(localStorage.getItem("profile"));
    const providerId = profile.role === "admin-sucursal" ? profile.employer._id : profile._id;

    await fetchAvailability(
      "dateAvailability/" + providerId,
      {
        data: {
          date: date,
          estimatedTime: editedEstimatedWorkMinutes,
          isInBranch: event.event.isInBranch,
          branch: event.event.branch._id,
          employee: event.event.admin_id,
          serviceCart: event.event.services?.map((e) => e.service._id) ?? [],
        },
      },
      {
        onSuccess: (response) => {
          response.data.availability.map((e) => {
            const _date = moment(e);
            if (isSameDay && _date.hours() <= today.hours()) {
              // return;
            }
            array.push({
              id: _date.hours() + _date.minutes() / 60,
              name: _date.format("HH:mm"),
            });
          });
          setHourPicker(array);
        },
      }
    );
  };
  // Guardar la hora del evento en estado separado
  useEffect(() => {
    if (event.event?.start) {
      const eventHourMoment = moment(event.event.start);
      const eventHourId = eventHourMoment.hours() + eventHourMoment.minutes() / 60;
      const eventHourName = eventHourMoment.format("HH:mm");

      setEventHour({ id: eventHourId, name: eventHourName });
    }
  }, [event.event?.start]);

  // Agregar la hora del evento una vez que hourPicker ha sido actualizado
  useEffect(() => {
    if (eventHour && !hourPicker.some((e) => e.id === eventHour.id)) {
      setHourPicker((prev) => [...prev, eventHour].sort((a, b) => a.id - b.id));
    }

    if (eventHour) {
      setValue("hour", eventHour.id); // Establecer la hora en el formulario
    }
  }, [hourPicker, eventHour]);
  return (
    <SelectInput
      source="hour"
      label="Hora"
      choices={hourPicker}
      fullWidth
      helperText={isDateBlocked || hourPicker.length === 0 ? "Sin horarios disponibles en esa fecha." : ""}
      sx={{
        "& .MuiPaper-root": {
          maxHeight: "200px",
          overflowY: "auto",
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            maxHeight: 200, // Limita la altura del menú
            overflowY: "auto", // Activa el scroll
          },
        },
      }}
    />
  );
};

const AvailableDateInput = ({ event, availability, blockedDates = [], busyDates, setIsDateBlocked, ...props }) => {
  return (
    <DateInput
      validate={[required()]}
      source="date"
      label="Fecha de reserva"
      inputVariant="outlined"
      event={event}
      options={{
        format: "dd/MM/yyyy",
        clearable: true,
        disablePast: true,
        defaultValue: `${event?.start ? new Date(event.start).toISOString() : null}`,
      }}
      defaultValue={event?.start ? new Date(event.start).toISOString() : null}
      providerOptions={{ locale: es }}
      shouldDisableDate={(day) => {
        const date = moment(day);
        const dayIndex = date.isoWeekday() - 1;
        const employeeAvailability = availability[dayIndex];
        if (employeeAvailability.length === 0) return true;
        const busyPeriods = busyDates
          .filter((busy) => moment(busy.start).isSame(date, "day"))
          .map(({ start, end }) => ({
            start: moment(start).hours() * 60 + moment(start).minutes(),
            end: moment(end).hours() * 60 + moment(end).minutes(),
          }));
        const availableMinutes = new Set();
        employeeAvailability.forEach(({ startHour, startMinute, endHour, endMinute }) => {
          for (let i = startHour * 60 + startMinute; i < endHour * 60 + endMinute; i++) {
            availableMinutes.add(i);
          }
        });

        busyPeriods.forEach(({ start, end }) => {
          for (let i = start; i < end; i++) {
            availableMinutes.delete(i);
          }
        });
        const allIntervalsBusy = availableMinutes.size === 0;
        const isBlocked =
          date < moment().startOf("day") ||
          allIntervalsBusy ||
          blockedDates.some((blockedDate) => date.isSame(blockedDate, "day")) ||
          availability[date.isoWeekday() - 1].length === 0;
        return isBlocked;
      }}
      setIsDateBlocked={setIsDateBlocked}
      {...props}
    />
  );
};

const DialogServices = ({ event, branch, handleCloseEditServicesModal }) => {
  const dataProvider = useDataProvider();
  const redirect = useRedirect();
  const notify = useNotify();
  const [update, { loading }] = useUpdate();
  const refresh = useRefresh();

  const [allServices, setAllServices] = useState([]);
  const [availableServices, setAvailableServices] = useState([]);
  const [availableRemoveServices, setAvailableRemoveServices] = useState([]);
  const [branchData, setBranchData] = useState(null);
  const [employee, setEmployee] = useState(null);
  const [selectedRemoveService, setSelectedRemoveService] = useState(null);
  const [servicesCart, setServicesCart] = useState(event?.services || []);
  const [selectedAddService, setSelectedAddService] = useState(null);

  const handleUpdate = (data) => {
    // Validar que haya al menos un servicio en el carrito
    if (!servicesCart || servicesCart.length === 0) {
      notify("Debe haber al menos un servicio en el carrito para actualizar la reserva", "warning");
      return;
    }

    const totalEstimatedWorkMinutes = servicesCart.reduce(
      (a, b) => a + b.service.unitEstimatedWorkMinutes * b.quantity,
      0
    );

    const totalPrice = servicesCart.reduce((a, b) => a + b.service.unitPrice * b.quantity, 0);

    update(
      "booking",
      {
        id: event.event_id,
        data: {
          serviceCart: servicesCart,
          totalPrice: totalPrice,
          totalEstimatedWorkMinutes: totalEstimatedWorkMinutes,
        },
        meta: { customAction: "updateServices" },
      },
      {
        onSuccess: (updatedData) => {
          notify("Servicios de la reserva actualizados con éxito", "success");
          handleCloseEditServicesModal();
          redirect(`/schedule?date=${updatedData.bookingDate}`);
          refresh();
        },
        onFailure: (error) => notify(`Error al actualizar: ${error.message}`, "warning"),
      }
    );
  };

  const branchId = event.branch._id;
  const employeeId = event.admin_id;

  useEffect(() => {
    dataProvider
      .getOne("employee", { id: employeeId })
      .then((employee) => {
        if (employee.data) setEmployee(employee.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, [employeeId]);

  useEffect(() => {
    dataProvider
      .getOne("enterprise/branches", { id: branchId })
      .then((branch) => {
        if (branch.data) {
          setBranchData(branch.data);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, [branchId]);

  useEffect(() => {
    if (branchData) {
      dataProvider
        .getList("service", {
          enabled: true,
          filter: {},
        })
        .then(({ data }) => {
          const transformedServices = data.map((service) => ({
            ...service,
            id: service._id,
          }));

          setAllServices(transformedServices);
        })
        .catch((error) => {
          console.error("Error al cargar los servicios:", error);
        });
    }
  }, [branchData]);

  useEffect(() => {
    if (allServices.length > 0 && branchData) {
      const servicesByBranch = allServices.filter((service) => branchData?.services?.includes(service._id));

      let filteredServices = [];

      if (employee?.availableServices && employee.availableServices.length > 0) {
        // Si el empleado tiene servicios disponibles, usar esos
        filteredServices = servicesByBranch.filter((service) => employee.availableServices.includes(service._id));
      } else {
        // Si no tiene servicios, usar todos los de la sucursal
        filteredServices = servicesByBranch;
      }

      setAvailableServices(filteredServices);
    }
  }, [allServices, branchData, employee]);

  useEffect(() => {
    if (servicesCart.length > 0 && allServices.length > 0) {
      const filteredServices = allServices.filter((service) => servicesCart.some((s) => service._id === s.service._id));

      setAvailableRemoveServices(filteredServices);
    }
  }, [servicesCart, allServices]);

  const isDuplicated = (serviceId, services) => {
    const filteredServices = services.filter((service) => service.service._id === serviceId);
    if (filteredServices.length > 0) return true;
    return false;
  };

  const handleAddService = () => {
    if (selectedAddService) {
      if (isDuplicated(selectedAddService, servicesCart)) {
        const updatedCart = servicesCart.map((item) => {
          if (item?.service?._id === selectedAddService) {
            return {
              ...item,
              quantity: item.quantity + 1,
            };
          }
          return item;
        });

        setServicesCart(updatedCart);
        return;
      }

      const service = availableServices.find((service) => service._id === selectedAddService);

      const timeNow = new Date().toISOString();

      const newItem = {
        createdAt: timeNow,
        estimatedWorkminutes: service.unitEstimatedWorkMinutes,
        price: service.unitPrice,
        quantity: 1,
        service: {
          name: service.name,
          unitEstimatedWorkMinutes: service.unitEstimatedWorkMinutes,
          unitPrice: service.unitPrice,
          _id: service._id,
        },
        updateAt: timeNow,
        _id: service._id,
      };

      setServicesCart((prev) => [...prev, newItem]);
    }
  };

  const isQuantityGreaterThanTwo = (serviceId, services) => {
    const filteredServices = services.filter((service) => service.service._id === serviceId);
    if (filteredServices && filteredServices?.[0]?.quantity >= 2) return true;
    return false;
  };

  const handleRemoveService = () => {
    if (selectedRemoveService) {
      if (isQuantityGreaterThanTwo(selectedRemoveService, servicesCart)) {
        const updatedCart = servicesCart.map((item) => {
          if (item?.service?._id === selectedRemoveService) {
            return {
              ...item,
              quantity: item.quantity - 1,
            };
          }
          return item;
        });

        setServicesCart(updatedCart);
        return;
      }

      const newServiceCart = servicesCart.filter((service) => service.service._id !== selectedRemoveService);

      setServicesCart(newServiceCart);
    }
  };

  return (
    <DialogContent sx={{ width: "auto" }}>
      <SimpleForm
        sx={{
          padding: "0px",
          margin: 0,
        }}
        toolbar={false}
        onSubmit={handleUpdate}
      >
        <Box
          sx={{
            display: "flex",
            gap: "5px",
            width: "400px",
          }}
        >
          <Box
            sx={{
              flex: 1,
              width: "50%",
            }}
          >
            <h5 style={{ padding: 0, margin: 0, fontWeight: 500 }}>Seleccione un servicio para agregar al carrito:</h5>
            <SelectInput
              sx={{
                height: "50px",
              }}
              source="addService"
              label="Servicios"
              fullWidth
              choices={availableServices}
              onChange={(e) => setSelectedAddService(e.target.value)}
            />

            <Button
              sx={{
                height: "40px",
                backgroundColor: "#00C853",
                color: "white",
                "&:hover": {
                  backgroundColor: "#00B248",
                },
                padding: "5px",
                marginBottom: "10px",
              }}
              variant="contained"
              onClick={handleAddService}
              fullWidth
            >
              Agregar servicio
            </Button>
          </Box>

          <Box
            sx={{
              flex: 1,
              width: "50%",
            }}
          >
            <h5 style={{ padding: 0, margin: 0, fontWeight: 500 }}>
              Seleccione un servicio para eliminar del carrito:
            </h5>
            <SelectInput
              sx={{
                height: "50px",
              }}
              source="removeService"
              label="Servicios"
              fullWidth
              choices={availableRemoveServices}
              onChange={(e) => setSelectedRemoveService(e.target.value)}
            />
            <Button
              sx={{
                height: "40px",
                backgroundColor: "#F44336",
                color: "white",
                "&:hover": {
                  backgroundColor: "#D32F2F",
                },
                padding: "5px",
                marginBottom: "10px",
              }}
              variant="contained"
              onClick={handleRemoveService}
              fullWidth
            >
              Eliminar servcio
            </Button>
          </Box>
        </Box>

        <h5 style={{ padding: "10px 0 0 0", marginBottom: 0, fontWeight: 500 }}>Lista de servicios en el carrito:</h5>

        <ul
          style={{
            width: "100%",
            listStyle: "none",
            padding: 0,
            margin: "5px 0px",
            height: "200px",
            overflowY: "auto",
          }}
        >
          {servicesCart.map((service) => (
            <li
              key={service?.service?._id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#ffffff",
                border: "1px solid #ddd",
                borderRadius: "12px",
                padding: "10px 16px",
                marginBottom: "8px",
                fontSize: "14px",
                fontWeight: "600",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                transition: "box-shadow 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.05)";
              }}
            >
              <span style={{ color: "#333" }}>{service.service.name}</span>
              <span
                style={{
                  backgroundColor: "#ffe8d2",
                  color: "#d35400",
                  padding: "2px 8px",
                  borderRadius: "9999px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                x{service.quantity}
              </span>
            </li>
          ))}
        </ul>

        {servicesCart.length === 0 && (
          <div
            style={{
              backgroundColor: "#fff3cd",
              border: "1px solid #ffeaa7",
              borderRadius: "8px",
              padding: "12px",
              margin: "10px 0",
              textAlign: "center",
              color: "#856404",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            ⚠️ Debe agregar al menos un servicio al carrito para poder<br></br> actualizar la reserva
          </div>
        )}

        <SaveButton fullWidth disabled={loading || servicesCart.length === 0} />
      </SimpleForm>
      <Button variant="contained" color="error" onClick={handleCloseEditServicesModal} fullWidth>
        Cancelar
      </Button>
    </DialogContent>
  );
};

const DialogDate = ({ scheduler, serviceMethod, branch, handleClose, setDate }) => {
  console.log("🔍 DialogDate - Props recibidas:", { scheduler, serviceMethod, branch, handleClose, setDate });
  console.log("🔍 DialogDate - scheduler.event:", scheduler?.event);
  console.log("🔍 DialogDate - branch type:", typeof branch, branch);

  const [update, { loading }] = useUpdate();
  const notify = useNotify();
  const { provider } = useProvider();
  const intervalMinutes = provider?.intervalMinutes || 30;

  // Generar choices dinámicamente según intervalMinutes
  const maxMinutes = 8 * 60; // 8 horas máximo
  const choices = Array.from({ length: Math.floor(maxMinutes / intervalMinutes) + 1 }, (_, i) => {
    const value = i * intervalMinutes;
    let name;
    if (value === 0) {
      name = "0 Minutos";
    } else if (value < 60) {
      name = `${value} Minutos`;
    } else if (value % 60 === 0) {
      name = `${value / 60} Hora${value === 60 ? "" : "s"}`;
    } else {
      name = `${Math.floor(value / 60)} Hora${Math.floor(value / 60) > 1 ? "s" : ""} ${value % 60} Minutos`;
    }
    return { id: value, name };
  });

  const initAvailability = {
    0: [],
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
  };
  const [availability, setAvailability] = useState(initAvailability);
  const [blockedDates, setBlockedDates] = useState([]);

  const branchId = branch?._id || branch || null;
  console.log("🔍 DialogDate - branchId calculado:", branchId);

  const { data: user } = useGetOne("availability", {
    id: scheduler?.event.admin_id ?? JSON.parse(localStorage.getItem("profile"))._id,
    meta: { branch: branchId },
  });

  console.log("🔍 DialogDate - user data:", user);

  const [isDateBlocked, setIsDateBlocked] = useState(false);
  const [busyDates, setBusyDates] = useState([]);
  const getBlockedDates = (unavailablePeriods) => {
    const blockedDates = [];

    unavailablePeriods.forEach(({ startDate, endDate }) => {
      const start = moment(startDate);
      const end = moment(endDate);

      const startDay = start.clone().startOf("day");
      const endDay = end.clone().startOf("day");

      while (startDay.isSameOrBefore(endDay)) {
        if (startDay.isSame(start, "day")) {
          if (start.hours() <= 8) {
            blockedDates.push(startDay.clone());
          }
        } else if (startDay.isSame(end, "day")) {
          if (end.hours() >= 23) {
            blockedDates.push(startDay.clone()); // Bloquear completamente
          }
        }
        // Días intermedios siempre bloqueados
        else {
          blockedDates.push(startDay.clone());
        }

        startDay.add(1, "day"); // Avanzar un día
      }
    });

    return blockedDates;
  };
  useEffect(() => {
    console.log("🔍 DialogDate useEffect - user:", user);

    if (user?.busy) {
      console.log("🔍 DialogDate - user.busy:", user.busy);
      setBusyDates(user?.busy);
    }

    if (user?.unavailability) {
      console.log("🔍 DialogDate - user.unavailability:", user.unavailability);
      setBlockedDates(getBlockedDates(user?.unavailability));
    }

    if (user?.availability) {
      console.log("🔍 DialogDate - user.availability:", user.availability);
      console.log("🔍 DialogDate - initAvailability:", initAvailability);

      try {
        const _availability = user.availability.reduce((array, e, index) => {
          console.log(`🔍 Reduce iteración ${index}:`, {
            e,
            dayIndex: e.dayIndex,
            currentArray: array,
            arrayAtDayIndex: array[e.dayIndex],
            isArray: Array.isArray(array[e.dayIndex]),
          });

          return {
            ...array,
            [e.dayIndex]: [...(array[e.dayIndex] || []), e],
          };
        }, initAvailability);

        console.log("🔍 DialogDate - _availability final:", _availability);
        setAvailability(_availability);
      } catch (error) {
        console.error("❌ Error en reduce de availability:", error);
        console.error("❌ user.availability:", user.availability);
      }
    }
  }, [user]);
  const redirect = useRedirect();
  const handleUpdate = (data) => {
    const { date, hour, editedEstimatedWorkMinutes } = data;
    update(
      "booking",
      {
        id: scheduler.event.event_id,
        data: {
          bookingDate: moment(date)
            .hours(hour)
            .minutes((hour % 1) * 60)
            .format(),
          totalEstimatedWorkMinutes: editedEstimatedWorkMinutes,
        },
        meta: { customAction: "updateDate" },
      },
      {
        onSuccess: (updatedData) => {
          notify("Fecha de la reserva actualizada con éxito", "success");
          handleClose();
          // setDate(moment(date).toISOString());
          redirect(`/schedule?date=${updatedData.bookingDate}`);
        },
        onFailure: (error) => notify(`Error al actualizar: ${error.message}`, "warning"),
      }
    );
  };
  return (
    <DialogContent>
      <Typography mb={2}>Seleccione la nueva fecha y hora:</Typography>
      <SimpleForm sx={{ padding: 0 }} toolbar={false} onSubmit={handleUpdate}>
        <AvailableDateInput
          event={scheduler?.event}
          availability={availability}
          blockedDates={blockedDates}
          setIsDateBlocked={setIsDateBlocked}
          busyDates={busyDates}
        />
        <br />
        <SelectInput
          // validate={[required()]}
          defaultValue={scheduler?.event?.totalEstimatedWorkMinutes}
          source="editedEstimatedWorkMinutes"
          label="Tiempo de servicio estimado"
          fullWidth
          choices={choices}
        />
        <HourInput event={scheduler} branch={branch} isDateBlocked={isDateBlocked} />
        <SaveButton fullWidth disabled={loading} />
      </SimpleForm>
      <Button variant="contained" color="error" onClick={handleClose} fullWidth>
        Cancelar
      </Button>
    </DialogContent>
  );
};
const status = (status) => {
  if (status === "Pendiente de cotizacion") {
    return [
      { id: "Pendiente de cotizacion", name: "Pendiente de cotización" },
      { id: "Confirmado", name: "Enviar cotización y confirmar" },
      // { id: "Pendiente", name: "Pendiente" },
      // { id: "Confirmado", name: "Confirmado" },
      // { id: "En proceso", name: "En proceso" },
      // { id: "Finalizado", name: "Finalizado" },
      { id: "Cancelada por el proveedor", name: "Cancelado" },
    ];
  }
  if (status === "Cotizacion enviada") {
    return [{ id: "Cotizacion enviada", name: "Cotización enviada" }];
  }
  if (status === "Pendiente") {
    return [
      { id: "Pendiente", name: "Pendiente" },
      { id: "Confirmado", name: "Confirmar" },
      { id: "Cancelada por el proveedor", name: "Cancelar" },
    ];
  }
  if (status === "Confirmado") {
    return [
      { id: "Confirmado", name: "Confirmado" },
      { id: "En proceso", name: "En proceso" },
      { id: "Finalizado", name: "Finalizar" },
      { id: "Cancelada por el proveedor", name: "Cancelar" },
    ];
  }
  if (status === "En proceso") {
    return [
      { id: "En proceso", name: "En proceso" },
      { id: "Finalizado", name: "Finalizar" },
      { id: "Cancelada por el proveedor", name: "Cancelar" },
    ];
  }
  if (status === "Finalizado") {
    return [{ id: "Finalizado", name: "Finalizado" }];
  }
  if (status === "Cancelada por el proveedor") {
    return [{ id: "Cancelada por el proveedor", name: "Cancelado por el proveedor" }];
  }
  if (status === "Cancelada por el cliente") {
    return [{ id: "Cancelada por el cliente", name: "Cancelado por el cliente" }];
  }
};
const BookingStatus = memo(({ event }) => {
  const [loading, setLoading] = useState(false);
  const [choices, setChoices] = useState(status(event.status));
  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useDataProvider();
  const handleChange = async (newStatus) => {
    setLoading(true);
    try {
      await dataProvider.update("booking", {
        id: event.event_id,
        data: { status: newStatus, previousStatus: event.status },
        meta: { customAction: "updateStatus" },
      });

      setChoices(status(newStatus));
      refresh();
      notify("Actualizado correctamente", { type: "success" });
    } catch (error) {
      console.error("Error al actualizar estado de pago:", error);
      notify("Error al actualizar", { type: "error" });
    } finally {
      setLoading(false);
    }
  };
  return (
    <SimpleForm
      toolbar={false}
      sx={{
        padding: 0,
        "&:last-child": { paddingBottom: 0 },
      }}
    >
      <SelectInput
        source="status"
        label="Estado de Reserva"
        choices={choices}
        disabled={loading}
        defaultValue={event.status}
        // value={event.status}
        onChange={(e) => {
          return handleChange(e.target.value);
        }}
        style={{
          margin: 0,
          padding: 0,
          height: "50px",
        }}
      />
    </SimpleForm>
  );
});
const Schedule = ({ date, setDate, setTimeUnit, serviceMethod, branch }) => {
  const profile = JSON.parse(localStorage.getItem("profile"));
  const { data } = useListContext();
  const calendarRef = useRef(null);
  const refresh = useRefresh();
  const { provider } = useProvider();
  const { data: branchSelected } = useGetOne("user/branch", {
    id: branch ? (profile.role === "admin-sucursal" ? branch._id : branch) : profile._id,
  });
  const intervalMinutes = provider?.intervalMinutes || 30;

  // Estado para el modal de Multi Reservas
  const [openMultiReservas, setOpenMultiReservas] = useState(false);
  const [multiReservasDate, setMultiReservasDate] = useState(null);
  useEffect(() => {
    if (Array.isArray(data)) {
      console.log("📅 Datos recibidos del backend:", data);
      console.log("📅 Total de eventos:", data[0]?.events?.length);
      console.log("📅 Eventos:", data[0]?.events);

      const filteredEvents = data[0].events.filter((event) => event.status !== "Cancelada por el proveedor");
      console.log("📅 Eventos después de filtrar cancelados:", filteredEvents.length);

      calendarRef.current.scheduler.handleState(data[0].resources, "resources");
      calendarRef.current.scheduler.handleState(
        filteredEvents.map((e) => ({
          ...e,
          start: new Date(e.start),
          end: new Date(e.end),
        })),
        "events"
      );
    }
  }, [data, date]);
  const [searchParams] = useSearchParams();

  const availabilityByDay =
    profile.role !== "admin-sucursal"
      ? branchSelected?.availability
        ? branchSelected?.availability?.reduce((acc, slot) => {
            if (!acc[slot.dayIndex]) acc[slot.dayIndex] = [];
            acc[slot.dayIndex].push(slot);
            return acc;
          }, {})
        : provider?.availability?.reduce((acc, slot) => {
            if (!acc[slot.dayIndex]) acc[slot.dayIndex] = [];
            acc[slot.dayIndex].push(slot);
            return acc;
          }, {})
      : branchSelected?.availability?.reduce((acc, slot) => {
          if (!acc[slot.dayIndex]) acc[slot.dayIndex] = [];
          acc[slot.dayIndex].push(slot);
          return acc;
        }, {});
  const computeDayRange = (slots = []) => {
    if (slots.length === 0) return [8, 22]; // fallback

    const start = Math.min(...slots.map((s) => s.startHour));
    const end = Math.max(...slots.map((s) => s.endHour));
    return [start, end];
  };
  const selectedDayIndex = moment(date).isoWeekday() - 1;
  const currentDaySlots = availabilityByDay?.[selectedDayIndex] || [];
  const [startHour, endHour] = computeDayRange(currentDaySlots);

  return (
    <>
      <Scheduler
        key={date}
        ref={calendarRef}
        view="day"
        events={[]}
        resources={[]}
        resourceFields={{
          idField: "admin_id",
          textField: "fullName",
          subTextField: "phone",
          avatarField: "fullName",
          colorField: "color",
        }}
        day={{
          startHour,
          endHour,
          step: intervalMinutes,
          navigation: true,
          cellRenderer: (props) => {
            if (!props || !props.start || !props.admin_id) {
              return (
                <div
                  onClick={props.onClick}
                  style={{
                    backgroundColor: "#FFFFFF",
                    height: "100%",
                    cursor: "pointer",
                    transition: "background-color 0.3s ease, border 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#F0F8FF";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#FFFFFF";
                  }}
                />
              );
            }
            const cellStart = moment(props.start);
            const cellHour = cellStart.hour();
            const cellDayIndex = cellStart.isoWeekday() - 1;

            // eslint-disable-next-line react-hooks/rules-of-hooks
            const { data } = useListContext();
            if (!Array.isArray(data) || !data[0]?.resources) {
              return <div style={{ height: "100%", backgroundColor: "#FFFFFF" }} />;
            }
            const employee = data[0].resources.find((resource) => resource.admin_id === props.admin_id);
            if (employee === undefined) {
              return <div style={{ height: "100%", backgroundColor: "#FFFFFF" }} />;
            }
            if (employee.admin_id === 0) {
              console.log("employee not found");
            }

            if (!employee) {
              return <div style={{ height: "100%", backgroundColor: "#FFFFFF" }} />;
            }

            let isAvailable = false;
            if (!Array.isArray(employee.availability) || employee.availability.length === 0) {
              // isAvailable = true;
              isAvailable = cellDayIndex >= 0 && cellDayIndex <= 5; // de lunes a sabado
            } else {
              isAvailable = employee.availability.some((slot) => {
                const slotStartHour = slot.startHour;
                const slotEndHour = slot.endHour;
                const slotStartMinute = slot.startMinute;
                const slotEndMinute = slot.endMinute;
                const slotDayIndex = slot.dayIndex; // Día de la semana en índice

                if (cellDayIndex !== slotDayIndex) {
                  return false;
                }

                const cellMinutes = cellStart.hour() * 60 + cellStart.minute();
                const slotStartMinutes = slotStartHour * 60 + slotStartMinute;
                const slotEndMinutes = slotEndHour * 60 + slotEndMinute;

                return cellMinutes >= slotStartMinutes && cellMinutes < slotEndMinutes;
              });
            }

            return (
              <div
                onClick={props.onClick}
                style={{
                  backgroundColor: isAvailable ? "#FFFFFF" : "#D3D3D3",
                  height: "100%",
                  border: isAvailable ? "" : "1px solid #A9A9A9", // 🔹 Azul si disponible, gris si no
                  cursor: "pointer",
                  transition: "background-color 0.3s ease, border 0.3s ease", // 🔹 Transición suave
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = isAvailable ? "#F0F8FF" : "#B0B0B0"; // 🔹 Azul claro si disponible, gris más oscuro si no
                  e.target.style.border = isAvailable ? "" : "1px solid #808080"; // 🔹 Borde más fuerte
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = isAvailable ? "#FFFFFF" : "#D3D3D3"; // 🔹 Volver al color original
                  e.target.style.border = isAvailable ? "" : "1px solid #A9A9A9"; // 🔹 Volver al borde original
                }}
              />
            );
          },
        }}
        week={{
          startHour: 8,
          endHour: 22,
          step: intervalMinutes,
          navigation: true,
          cellRenderer: (props) => {
            if (!props || !props.start || !props.admin_id) {
              return (
                <div
                  onClick={props.onClick}
                  style={{
                    backgroundColor: "#FFFFFF",
                    height: "100%",
                    cursor: "pointer",
                    transition: "background-color 0.3s ease, border 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#F0F8FF";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#FFFFFF";
                  }}
                />
              );
            }

            const cellStart = moment(props.start);
            const cellDayIndex = cellStart.isoWeekday() - 1; // 🔹 Lunes = 0, Martes = 1, etc.
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const { data } = useListContext();

            if (!Array.isArray(data) || !data[0]?.resources) {
              return <div style={{ height: "100%", backgroundColor: "#D3D3D3" }} />;
            }

            const employee = data[0].resources.find((resource) => resource.admin_id === props.admin_id);

            if (!employee) {
              return <div style={{ height: "100%", backgroundColor: "#D3D3D3" }} />;
            }

            let isAvailable = false;
            if (props.admin_id === 0) {
              isAvailable = cellDayIndex >= 0 && cellDayIndex <= 5; // de lunes a sabado
              // isAvailable = true;
            } else if (!Array.isArray(employee.availability) || employee.availability.length === 0) {
              isAvailable = cellDayIndex >= 0 && cellDayIndex <= 5; // de lunes a sabado
              // isAvailable = true;
            } else {
              isAvailable = employee.availability.some((slot) => {
                const slotStartHour = slot.startHour;
                const slotEndHour = slot.endHour;
                const slotStartMinute = slot.startMinute;
                const slotEndMinute = slot.endMinute;
                const slotDayIndex = slot.dayIndex; // Día de la semana en índice

                if (cellDayIndex !== slotDayIndex) {
                  return false;
                }

                const cellMinutes = cellStart.hour() * 60 + cellStart.minute();
                const slotStartMinutes = slotStartHour * 60 + slotStartMinute;
                const slotEndMinutes = slotEndHour * 60 + slotEndMinute;

                return cellMinutes >= slotStartMinutes && cellMinutes < slotEndMinutes;
              });
            }
            return (
              <div
                onClick={props.onClick}
                style={{
                  backgroundColor: isAvailable ? "#FFFFFF" : "#D3D3D3",
                  height: "100%",
                  border: isAvailable ? "" : "1px solid #A9A9A9", // 🔹 Azul si disponible, gris si no
                  cursor: "pointer",
                  transition: "background-color 0.3s ease, border 0.3s ease", // 🔹 Transición suave
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = isAvailable ? "#F0F8FF" : "#B0B0B0"; // 🔹 Azul claro si disponible, gris más oscuro si no
                  e.target.style.border = isAvailable ? "" : "1px solid #808080"; // 🔹 Borde más fuerte
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = isAvailable ? "#FFFFFF" : "#D3D3D3"; // 🔹 Volver al color original
                  e.target.style.border = isAvailable ? "" : "1px solid #A9A9A9"; // 🔹 Volver al borde original
                }}
              />
            );
          },
        }}
        month={{
          navigation: true,
          cellRenderer: (props) => {
            if (!props || !props.day || !props.admin_id) {
              return (
                <div
                  onClick={props.onClick}
                  style={{
                    backgroundColor: "#FFFFFF",
                    height: "100%",
                    cursor: "pointer",
                    transition: "background-color 0.3s ease, border 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#F0F8FF";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#FFFFFF";
                  }}
                />
              );
            }
            const cellDayIndex = moment(props.end).isoWeekday() - 1;
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const { data } = useListContext();

            if (!Array.isArray(data) || !data[0]?.resources) {
              return <div style={{ height: "100%", backgroundColor: "#D3D3D3" }} />;
            }

            const employee = data[0].resources.find((resource) => resource.admin_id === props.admin_id);

            if (!employee) {
              return <div style={{ height: "100%", backgroundColor: "#D3D3D3" }} />;
            }

            let isAvailable = false;
            if (!Array.isArray(employee.availability) || employee.availability.length === 0) {
              isAvailable = cellDayIndex >= 0 && cellDayIndex <= 5; // de lunes a sabado
              // isAvailable = true;
            } else {
              isAvailable = employee.availability.some((slot) => {
                const slotDayIndex = slot.dayIndex;
                return cellDayIndex === slotDayIndex;
              });
            }

            return (
              <div
                onClick={props.onClick}
                style={{
                  backgroundColor: isAvailable ? "#FFFFFF" : "#D3D3D3",
                  height: "100%",
                  border: isAvailable ? "" : "1px solid #A9A9A9",
                  cursor: "pointer",
                  transition: "background-color 0.3s ease, border 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = isAvailable ? "#F0F8FF" : "#B0B0B0";
                  e.target.style.border = isAvailable ? "" : "1px solid #808080";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = isAvailable ? "#FFFFFF" : "#D3D3D3";
                  e.target.style.border = isAvailable ? "" : "1px solid #A9A9A9";
                }}
              />
            );
          },
        }}
        translations={{
          navigation: {
            month: "Mes",
            week: "Semana",
            day: "Día",
            today: "Hoy",
          },
          form: {
            addTitle: "Crear Reserva",
            editTitle: "Ver Reserva",
            confirm: "Confirmar",
            delete: "Borrar",
            cancel: "Cancelar",
          },
          event: {
            title: "Título",
            start: "Inicio",
            end: "Final",
            allDay: "Todo el día",
          },
          moreEvents: "Más...",
          loading: "Cargando...",
        }}
        locale={es}
        selectedDate={new Date(date)}
        onSelectedDateChange={(d) => setDate(d.toISOString())}
        onViewChange={(v) => setTimeUnit(v)}
        deletable={false}
        draggable={false}
        editable={false}
        customEditor={(scheduler) => (
          <CustomEditor
            scheduler={scheduler}
            branch={branch}
            serviceMethod={serviceMethod}
            refresh={refresh}
            onOpenMultiReservas={(date) => {
              setMultiReservasDate(date);
              setOpenMultiReservas(true);
            }}
          />
        )}
        eventRenderer={({ event, onClick }) => {
          return (
            <ButtonBase onClick={onClick}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: event.type === "unavailability" ? "#D3D3D3" : STATUS_COLORS[event.status],
                  height: "100%",
                }}
              >
                {event?.paymentInfo?.partialPayment > 0 && event?.paymentInfo?.status !== "Pagado" && (
                  <div
                    style={{
                      width: "1rem",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#4CAF50",
                      borderRight: "1px solid #fff",
                    }}
                  >
                    <MoneyOff style={{ color: "#FFF", fontSize: "1rem" }} />
                  </div>
                )}
                {event?.paymentInfo?.status === "Pagado" && (
                  <div
                    style={{
                      width: "1rem",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#4CAF50",
                      borderRight: "1px solid #fff",
                    }}
                  >
                    <AttachMoney style={{ color: "#FFF", fontSize: "1rem" }} />
                  </div>
                )}
                <div
                  style={{
                    flex: 1,
                    padding: "4px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography variant="subtitle2" style={{ fontSize: "x-small" }}>
                    {event.title}
                  </Typography>
                  {event.type === "booking" && (
                    <Typography style={{ fontSize: "x-small" }}>
                      {format(event.start, `HH:mm`, {
                        locale: es,
                      })}{" "}
                      -
                      {format(event.end, `HH:mm`, {
                        locale: es,
                      })}
                    </Typography>
                  )}
                  {event.type === "booking" && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "left",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        style={{
                          width: "auto",
                          fontSize: "x-small",
                        }}
                      >
                        {event.status}
                      </Typography>
                      {event?.feedbackInfo && event?.feedbackInfo?.rating && (
                        <div
                          style={{
                            width: "auto",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            textAlign: "center",
                            paddingBottom: "3px",
                          }}
                        >
                          <Typography
                            style={{ fontWeight: "500", fontSize: "x-small", width: "0.75rem", height: "0.75rem" }}
                          >
                            {event.feedbackInfo.rating}
                          </Typography>
                          <Star style={{ color: "#FFD700", width: "0.75rem", height: "0.75rem" }} />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </ButtonBase>
          );
        }}
        viewerExtraComponent={(fields, event) => {
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const [openCancelModal, setOpenCancelModal] = useState(false);
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const [cancelReason, setCancelReason] = useState("");
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const [open, setOpen] = useState(false); // Estado para el modal
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const [openEditServicesModal, setOpenEditServicesModal] = useState(false);
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const [update, { loading }] = useUpdate();
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const notify = useNotify();
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const { refetch } = useListContext();
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const navigate = useNavigate();
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const dateBooking = moment(event.createdAt).locale("es").format("dddd D [de] MMMM [de] YYYY, HH:mm");

          const WhatsAppField = ({ phone, countryCode }) => {
            if (!phone) return null;
            const code = countryCode ? countryCode : "";
            return (
              <a
                href={`https://wa.me/${code}${phone}`}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "underline", color: "#FF770D", marginLeft: 8 }}
              >
                {phone}
              </a>
            );
          };

          const ReminderButton = ({ phone, countryCode, customerName, services, bookingDate }) => {
            if (!phone) return null;

            const generateReminderMessage = () => {
              const code = countryCode ? countryCode : "";
              const date = moment(bookingDate);
              const dayName = date.format("dddd");
              const dayNumber = date.format("D");
              const monthName = date.format("MMMM");
              const year = date.format("YYYY");
              const time = date.format("h:mm A");

              // Obtener nombres de servicios
              const serviceNames = services?.map((s) => s.service?.name || s.name).join(", ") || "su servicio";

              const message = `Hola ${customerName}! Te recordamos tu cita de ${serviceNames} para el ${dayName} ${dayNumber} de ${monthName} de ${year} a las ${time}. ¡Te esperamos!`;

              return `https://wa.me/${code}${phone}?text=${encodeURIComponent(message)}`;
            };

            return (
              <Tooltip title="Recordatorio" arrow>
                <IconButton
                  size="small"
                  onClick={() => window.open(generateReminderMessage(), "_blank")}
                  sx={{
                    marginLeft: 1,
                    padding: "4px",
                    color: "#25D366",
                    "&:hover": {
                      color: "#128C7E",
                      backgroundColor: "rgba(37, 211, 102, 0.08)",
                    },
                  }}
                >
                  <WhatsApp fontSize="small" />
                </IconButton>
              </Tooltip>
            );
          };

          const FormsField = ({ formResponsesCount, customerId }) => {
            if (!formResponsesCount || formResponsesCount === 0) return null;
            return (
              <Typography
                variant="body2"
                marginLeft={1}
                onClick={() => navigate(`/enterprise/customers/${customerId}/forms`)}
                style={{
                  textDecoration: "underline",
                  color: "#FF770D",
                  cursor: "pointer",
                  userSelect: "none",
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "#E65100";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "#FF770D";
                }}
              >
                {`${formResponsesCount} formulario${formResponsesCount > 1 ? "s" : ""}`}
              </Typography>
            );
          };

          const InfoItem = ({
            icon,
            label,
            value,
            countryCode,
            formResponsesCount,
            customerId,
            customerName,
            services,
            bookingDate,
          }) => {
            return (
              <Box display="flex" marginTop={label === "Estado" ? 2 : 1} alignItems="center">
                <Box display="flex">
                  {icon}
                  <Typography variant="body2" fontWeight="bold" sx={{ ml: 1 }}>
                    {label}:
                  </Typography>
                </Box>
                {label === "Teléfono" ? (
                  <Box display="flex" alignItems="center">
                    <WhatsAppField phone={value} countryCode={countryCode} />
                    <ReminderButton
                      phone={value}
                      countryCode={countryCode}
                      customerName={customerName}
                      services={services}
                      bookingDate={bookingDate}
                    />
                  </Box>
                ) : label === "Formularios" ? (
                  <FormsField formResponsesCount={formResponsesCount} customerId={customerId} />
                ) : (
                  <Typography variant="body2" marginLeft={1}>
                    {value}
                  </Typography>
                )}
              </Box>
            );
          };

          const cancel = () =>
            update(
              "booking",
              {
                id: event.event_id,
                data: { cancelReason: cancelReason.trim() },
                meta: { customAction: "toCancelledByProvider" },
              },
              {
                onSuccess: (data) => {
                  const redirectParam = searchParams.get("redirect")
                    ? searchParams.get("redirect") + "?date=" + data.bookingDate
                    : null;
                  notify("Reserva cancelada con éxito");
                  refetch();
                  setOpenCancelModal(false); // Cierra el modal
                  setCancelReason(""); // Limpia el campo
                },
                onFailure: (error) => notify(`Error al cancelar reserva: ${error}`, "warning"),
              }
            );

          const handleOpen = () => setOpen(true);
          const handleClose = () => setOpen(false);
          const handleOpenEditServicesModal = () => setOpenEditServicesModal(true);
          const handleCloseEditServicesModal = () => setOpenEditServicesModal(false);

          const getStatusIcon = (status) => {
            const icons = {
              "Pendiente de cotización": <HourglassEmpty fontSize="small" />,
              "Cotización enviada": <MarkEmailRead fontSize="small" />,
              Pendiente: <PendingActions fontSize="small" />,
              Confirmado: <CheckCircle fontSize="small" />,
              "En proceso": <Autorenew fontSize="small" />,
              Finalizado: <Beenhere fontSize="small" />,
              Cancelado: <Cancel fontSize="small" />,
              "Cancelado por el cliente": <DoNotDisturb fontSize="small" />,
              "Cancelado por el proveedor": <ReportProblem fontSize="small" />,
            };

            return icons[status] || <Cancel color="disabled" />; // Icono por defecto si no hay coincidencia
          };

          const ServicesList = ({ event }) => {
            return (
              <>
                <p
                  style={{
                    fontSize: "13px",
                    fontWeight: "600",
                    margin: "0 0 6px 0",
                    padding: "0",
                    borderBottom: "1px solid #ccc",
                    color: "#444",
                  }}
                >
                  Lista de Servicios:
                </p>
                <div
                  style={{
                    height: "100px",
                    width: "150px",
                    overflowX: "hidden",
                    overflowY: "auto",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  <ul
                    style={{
                      listStyleType: "none",
                      padding: "0",
                      margin: "0",
                    }}
                  >
                    {event.services.map((service) => (
                      <li
                        key={service?._id}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          fontSize: "12px",
                          fontWeight: "500",
                          backgroundColor: "#f9f9f9",
                          padding: "4px 8px",
                          marginBottom: "4px",
                          borderRadius: "6px",
                          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                        }}
                      >
                        <span
                          style={{
                            color: "#333",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            maxWidth: "100px",
                          }}
                        >
                          {service.service.name}
                        </span>
                        <span
                          style={{
                            backgroundColor: "#ffe8d2",
                            color: "#d35400",
                            fontWeight: "bold",
                            fontSize: "11px",
                            padding: "1px 6px",
                            borderRadius: "999px",
                          }}
                        >
                          x{service.quantity}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </>
            );
          };

          return (
            <div>
              <Divider sx={{ my: 1, bgcolor: "rgba(0, 0, 0, 0.1)" }} />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Box
                    sx={{
                      flex: "2",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "left",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <InfoItem icon={<Tag fontSize="small" />} label="ID" value={event?.event_id || "No disponible"} />
                      {event?.serviceInfo &&
                        event?.currentSession &&
                        event?.serviceInfo?.package?.isEnabled &&
                        event.serviceInfo?.package?.quantity && (
                          <Typography fontSize="small" fontWeight={700} marginTop={1}>
                            {`|  Sesión ${event?.currentSession} de ${event?.serviceInfo?.package?.quantity}`}
                          </Typography>
                        )}
                    </div>
                    <InfoItem
                      icon={<Phone fontSize="small" />}
                      label="Teléfono"
                      value={event?.phone || "No disponible"}
                      countryCode={event?.countryCode}
                      customerName={event?.title || event?.customer?.fullName || "Cliente"}
                      services={event?.services}
                      bookingDate={event?.start}
                    />
                    {event?.formResponsesCount > 0 && (
                      <InfoItem
                        icon={<Description fontSize="small" />}
                        label="Formularios"
                        value={`${event.formResponsesCount} formulario${event.formResponsesCount > 1 ? "s" : ""}`}
                        formResponsesCount={event.formResponsesCount}
                        customerId={event.customerId ?? event.customer?._id}
                      />
                    )}
                    <InfoItem
                      icon={<Computer fontSize="small" />}
                      label="Método de reserva"
                      value={event?.createdFrom || "-"}
                    />
                    <InfoItem
                      icon={<Discount fontSize="small" />}
                      label="Campaña de descuento"
                      value={event?.paymentInfo?.coupon?.name || "-"}
                    />
                  </Box>
                  <Box
                    sx={{
                      flex: "1",
                    }}
                  >
                    {event?.services && <ServicesList event={event} />}
                  </Box>
                </Box>

                {event?.status !== "No disponible" && (
                  <InfoItem icon={getStatusIcon(event.status)} label="Estado" value={<BookingStatus event={event} />} />
                )}
                <Typography fontSize="x-small" fontWeight={700} marginTop={0}>
                  {`Fecha de reserva: ${dateBooking}`}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 0.5, // 🔹 Menos espacio entre los botones
                  mt: 0.5, // 🔹 Menos margen superior
                  justifyContent: "space-between",
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={handleOpen}
                  disabled={event.remainingDateChanges <= 0 || event.type === "unavailability"}
                  sx={{
                    flex: 1,
                    minWidth: "90px", // 🔹 Más pequeño
                    maxWidth: "110px",
                    textAlign: "center",
                    whiteSpace: "normal",
                    padding: "4px",
                    fontSize: "10px",
                    color: "white",
                  }}
                >
                  Modificar <br /> Fecha
                </Button>

                <Button
                  disabled={event.status === "Finalizado"}
                  variant="contained"
                  size="small"
                  onClick={handleOpenEditServicesModal}
                  sx={{
                    backgroundColor: "#FFA500",
                    flex: 1,
                    minWidth: "90px",
                    maxWidth: "110px",
                    textAlign: "center",
                    whiteSpace: "normal",
                    padding: "4px",
                    fontSize: "10px",
                    color: "white",
                  }}
                >
                  Modificar <br /> Servicios
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => navigate(`/${event.type}/${event.event_id}/show?redirect=schedule`)}
                  sx={{
                    flex: 1,
                    minWidth: "90px",
                    maxWidth: "110px",
                    textAlign: "center",
                    whiteSpace: "normal",
                    padding: "4px",
                    fontSize: "10px",
                  }}
                >
                  Más <br /> Información
                </Button>

                <Button
                  variant="contained"
                  data-cy="cancel-button"
                  size="small"
                  color="error"
                  onClick={() => setOpenCancelModal(true)} // Abre el modal
                  disabled={event.type === "unavailability"}
                  sx={{
                    flex: 1,
                    minWidth: "90px",
                    maxWidth: "110px",
                    textAlign: "center",
                    whiteSpace: "normal",
                    padding: "4px",
                    fontSize: "10px",
                  }}
                >
                  Cancelar <br /> Reserva
                </Button>
              </Box>

              <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Modificar Fecha de Reserva</DialogTitle>
                <DialogDate scheduler={{ event }} branch={branch} handleClose={handleClose} setDate={setDate} />
              </Dialog>

              <Dialog open={openEditServicesModal} onClose={handleCloseEditServicesModal}>
                <DialogTitle> Editar los Servicios </DialogTitle>
                <DialogServices
                  event={event}
                  branch={branch}
                  handleCloseEditServicesModal={handleCloseEditServicesModal}
                />
              </Dialog>

              {/* ✅ MODAL DE CANCELACIÓN CON RAZÓN */}
              <Dialog
                open={openCancelModal}
                onClose={() => {
                  setOpenCancelModal(false);
                  setCancelReason("");
                }}
              >
                <DialogTitle>¿Por qué estás cancelando esta reserva?</DialogTitle>
                <DialogContent>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Por favor, indica la razón. Esto ayudará al cliente a entender lo sucedido.
                  </Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    label="Motivo de cancelación *"
                    type="text"
                    fullWidth
                    multiline
                    minRows={3}
                    maxRows={6}
                    value={cancelReason}
                    onChange={(e) => setCancelReason(e.target.value)}
                    required
                    placeholder="Ej: Cliente no pudo asistir, servicio ya no necesario..."
                    error={!cancelReason.trim()}
                    helperText={!cancelReason.trim() && "La razón es obligatoria"}
                    data-cy="input-cancel-reason"
                  />
                </DialogContent>
                <DialogActions sx={{ p: 2, pt: 0 }}>
                  <Button
                    onClick={() => {
                      setOpenCancelModal(false);
                      setCancelReason("");
                    }}
                    color="secondary"
                    variant="outlined"
                    data-cy="btn-cancel-modal"
                  >
                    Volver
                  </Button>
                  <Button
                    onClick={cancel}
                    color="error"
                    variant="contained"
                    disabled={!cancelReason.trim()}
                    data-cy="btn-confirm-cancel"
                  >
                    Confirmar Cancelación
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          );
        }}
      />
      <MultiReservasModal
        open={openMultiReservas}
        onClose={() => setOpenMultiReservas(false)}
        initialDate={multiReservasDate}
        branch={branch}
        serviceMethod={serviceMethod}
      />
    </>
  );
};

const SelectBranchInput = ({ serviceMethod, branch, setBranch }) => {
  const { data, loading, error } = useGetList("enterprise/branches", {
    filter: {
      status: true,
    },
  });

  return serviceMethod !== "A domicilio" ? (
    <FormControl>
      <InputLabel id="demo-simple-select-label">Sucursal</InputLabel>
      <Select
        style={{ width: 200 }}
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={branch || ""}
        label="Método"
        onChange={(e) => setBranch(e.target.value)}
      >
        {data?.map((e) => {
          return (
            <MenuItem key={e._id} value={e._id}>
              {e.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  ) : (
    <React.Fragment />
  );
};
